import { Button } from "@mui/material";

const ButtonsBar = ({ styles, t, campaign, onPrintQR, onOpenAddCash, onEditCampaign, onDelete, onArchive }) => {
  return (
    <div className={styles.campaign_buttons}>
      <div></div>
      <div className="space-x-4">
        <Button disabled={!campaign?.is_fundraiser} variant="contained" onClick={onPrintQR}>
          {t("print_qr")}
        </Button>

        <Button
          variant="contained"
          className={styles.add_cash_button}
          onClick={onOpenAddCash}
          disabled={campaign?.is_archived}
        >
          {t("addCash_text")}
        </Button>

        <Button
          variant="outlined"
          className={styles.edit_campaign_button}
          onClick={onEditCampaign}
          disabled={campaign?.is_archived}
        >
          {t("edit_campaign")}
        </Button>

        <Button
          color="error"
          variant="outlined"
          className={styles.delete_campaign_button}
          onClick={onDelete}
          disabled={campaign?.is_archived}
        >
          {t("delete_campaign")}
        </Button>

        <Button color="warning" variant="contained" className={styles.add_to_archive_button} onClick={onArchive}>
          {campaign?.is_archived ? t("remove_archives") : t("add_to_archives")}
        </Button>
      </div>
    </div>
  );
};

export default ButtonsBar;
